<script setup lang="ts">
import DarkModeSwitcher from "../../components/DarkModeSwitcher";
import { getAuth, signOut } from "firebase/auth";
import { userUserStore } from "../../stores/user";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import LoadingIcon from "../../base-components/LoadingIcon";
import router from "../../router";

import { soporteAtiendo } from "../../services/cloudFunctions/soporteAtiendo";
import { SoporteAtiendo, UsuarioEmpresas } from "@fixeduy/restaurantestypes";

const route = useRoute();
const ambiente = import.meta.env.VITE_ENV_NOMBRE;
const cargando = ref<boolean>(true);
const textoRespuesta = ref<string>("");
const userStore = userUserStore();

const cargarSoporteAtiendo = async () => {
  let idEmpresa = "";
  if (typeof route.params.idEmpresa == "string") {
    idEmpresa = route.params.idEmpresa;
  }

  const soporte: SoporteAtiendo = {
    empresaSolicitada: idEmpresa
  };

  const result = await soporteAtiendo(soporte);
  if (result.exito) {
    const auth = getAuth();
    // load token
    if (auth.currentUser != null) {
      auth.currentUser
        .getIdTokenResult(true)
        .then(async idTokenResult => {
          userStore.setUserToken(idTokenResult);
          const empresa = result.adicionalData as UsuarioEmpresas;
          await userStore.setEmpresasActual(empresa);
          router.replace("/");
        })
        .catch(() => {
          userStore.signOut();
          signOut(getAuth());
        });
    }
  } else {
    cargando.value = false;
    textoRespuesta.value =
      "Ops! Parece que no tienes permisos. Debes de iniciar sesión en /login con una cuenta de Atiendo";
  }
};

onMounted(async () => {
  await cargarSoporteAtiendo();
  await new Promise(resolve => setTimeout(resolve, 4000));
  localStorage.setItem("recargar_app", Date.now().toString());
});

const irProduccion = () => {
  window.location.href = "https://acceso.atiendo.cloud";
};
</script>

<template>
  <div
    :class="[
      '-m-3 sm:-mx-8 p-3 sm:px-8 relative h-screen lg:overflow-hidden bg-primary xl:bg-white dark:bg-darkmode-800 xl:dark:bg-darkmode-600',
      'before:hidden before:xl:block before:content-[\'\'] before:w-[57%] before:-mt-[28%] before:-mb-[16%] before:-ml-[13%] before:absolute before:inset-y-0 before:left-0 before:transform before:rotate-[-4.5deg] before:bg-primary/20 before:rounded-[100%] before:dark:bg-darkmode-400',
      'after:hidden after:xl:block after:content-[\'\'] after:w-[57%] after:-mt-[20%] after:-mb-[13%] after:-ml-[13%] after:absolute after:inset-y-0 after:left-0 after:transform after:rotate-[-4.5deg] after:bg-primary after:rounded-[100%] after:dark:bg-darkmode-700'
    ]"
  >
    <!-- <DarkModeSwitcher /> -->
    <div class="container relative z-10 sm:px-10">
      <div class="block grid-cols-2 gap-4 xl:grid">
        <!-- BEGIN: Login Info -->
        <div class="flex-col hidden min-h-screen xl:flex">
          <div class="my-auto">
            <!-- <img
              alt="Fixed"
              class="w-1/2 -mt-16 -intro-x"
              src="/logo_nuevo_blanco_x_color.png"
            /> -->
            <div
              class="mt-10 text-4xl font-medium leading-tight text-white -intro-x"
            >
              Soporte
              <template v-if="ambiente != 'Produccion'">
                <p class="mt-5 text-danger p-3 bg-white">Ambiente DEMO</p>
                <Button
                  variant="primary"
                  class="mb-2 mr-1"
                  @click="irProduccion"
                >
                  Ir a Atiendo
                </Button>
              </template>
            </div>
          </div>
        </div>
        <!-- END: Login Info -->
        <!-- BEGIN: Login Form -->
        <div class="flex h-screen py-5 my-10 xl:h-auto xl:py-0 xl:my-0">
          <div
            class="w-full px-5 py-8 mx-auto my-auto bg-white xl:ml-20 dark:bg-darkmode-600 bg-transparent"
          >
            <div v-if="cargando">
              <div
                class="flex flex-col items-center justify-end col-span-6 sm:col-span-3 xl:col-span-2"
              >
                <LoadingIcon icon="oval" class="w-8 h-8" />
              </div>
            </div>
            <div v-else>
              <p class="font-medium mb-5 text-center text-lg">
                {{ textoRespuesta }}
              </p>
            </div>
          </div>
        </div>
        <!-- END: Login Form -->
      </div>
    </div>
  </div>
</template>
